import { render, staticRenderFns } from "./BookingAdminMultiOrder.vue?vue&type=template&id=46849722&"
import script from "./BookingAdminMultiOrder.vue?vue&type=script&lang=js&"
export * from "./BookingAdminMultiOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports